<template>
	<div class="w-100 h-100  flex j-sb">
		<div class="top_item  m-r w-25 h-100">
			<dv-border-box-13>
				<div class="item flex flex-column h-100 j-sb">
					<div class="font-weight font-m">原材料总合计</div>
					<div class="font-weight font-l color-blue">{{data.yclKc}}<span class="font-s"></span></div>
					<div class="color-gray font flex j-sb flex-wrap">
						<span></span><span></span><span></span><span></span>
					</div>
				</div>

			</dv-border-box-13>
		</div>
		<div class="top_item  m-r w-25 h-100">
			<dv-border-box-13>
				<div class="item flex flex-column h-100 j-sb">
					<div class="font-weight font-m">成品库存</div>
					<div class="font-weight font-s color-blue flex j-sb">
						<span>数量:{{data.cpKc.sl}}</span>
						<span>支数:{{data.cpKc.zs}}</span>
						<span>张数:{{data.cpKc.zs1}}</span>
					</div>
					<div class="color-gray font flex j-sb flex-wrap">
						<span></span><span></span><span></span><span></span>
					</div>
				</div>

			</dv-border-box-13>
		</div>
		<div class="top_item  m-r w-25 h-100">
			<dv-border-box-13>
				<div class="item flex flex-column h-100 j-sb">
					<div class="font-weight font-m">未排订单数据</div>
					<div class="font-weight font-l color-blue">{{data.wpc}}<span class="font-s"></span></div>
					<div class="color-gray font flex j-sb flex-wrap">
						<span></span><span></span><span></span><span></span>
					</div>
				</div>

			</dv-border-box-13>
		</div>

	</div>

</template>

<script>
	export default {
		props: ['domain'],
		name: 'top_item',
		data() {
			return {
				data: {

			 }
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				this.$axios.get(`${this.domain}/skd/queryKcByYclCpWpc`).then(res => {
					this.data = res.data.data
				})
			}
		}

	}
</script>


<style scoped>
	.item {
		padding: 0.33rem 0.4rem 0.2rem;
	}
</style>



// WEBPACK FOOTER //
// src/views/片材/bottom_item.vue